import forbiddenComponent from './forbidden.component';

const forbiddenModule = angular
  .module('forbidden', [])
  .component('forbidden', forbiddenComponent);

export default forbiddenModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/forbidden/forbidden.js
 **/